import { render, staticRenderFns } from "./HistoryRow_wi.vue?vue&type=template&id=16e4cd7e"
import script from "./HistoryRow_wi.vue?vue&type=script&lang=js"
export * from "./HistoryRow_wi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports